import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Menu from './components/Menu';
import Home from './pages/Home';
import AnalysisPosts from './pages/AnalysisPosts'; 
import Sobre from './pages/Sobre';


import './App.css';
import ClassificationPage from './pages/DepressionClassifier';
import HomePage from './pages/HomePage';

function App() {
  return (
    <Router>
      <div className="App">
        <Menu />
        <div className="content">
          <Routes>
            <Route exact path="/" element={<HomePage />} />
            <Route exact path="/indicadores" element={<Home />} />
            <Route path="/montarconsulta" element={<AnalysisPosts />} />
            <Route path="/sobre" element={<Sobre />} />
            <Route path="/modelopreditor" element={<ClassificationPage />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
